module.exports = __webpack_public_path__ + "img/rd-nirmatrelvir-structure.72537f1e.png";